"use client";

export default function PublicFooterDate() {
  const currentYear = new Date().getFullYear();

  return <>{currentYear}</>;
}
